module.exports = __webpack_public_path__ + "img/body-bg.34829a76.png";